<template>
  <div class="mb-30">
    <div class="single-counter">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Ex. 0000.00.00"
          :readonly="this.$store.state.idCliente == '9475'"
          maxlength="10"
          aria-label
          aria-describedby="pesquisa ncm"
          v-model="pesquisa"
          @keyup.enter="pesquisar()"
          @keypress="mascara()"
          
        />

        <div class="input-group-prepend">
          <button class="btn btn-labeled btn-info" type="button" @click="pesquisar()">
            Pesquisar
            <div
              class="spinner-border text-white loading ml-2"
              v-if="loadingPesquisa"
              role="status"
            >
              <span class="sr-only">Aguarde...</span>
            </div>
          </button>
        </div>
      </div>
      <div class="erro" v-if="validacaoNcm">O número da NCM deve conter 8 dígitos</div>
      <p class="fs-12 texto-italico mt-5 box-nota p-2 centralizar">
        <strong>NOTA LEFISC:</strong><br/>
        <span class="d-inline-block mb-1 mt-1">Consulta na ferramenta de Monitoramento de NCM relativo ao ICMS tem como objetivo informar a alíquota interna do produto no Estado.</span>
        <span class="d-inline-block mb-1">Os benefícios fiscais como isenção, redução de base de cálculo, não-incidência ou, ainda, operações amparadas por diferimento ou suspensão, não estão contempladas, devendo ser consultada a legislação de cada Estado.</span>
        <span>Contudo, informamos que os benefícios fiscais da isenção, base de cálculo reduzida e da não-incidência estão em processo de elaboração pela equipe LEFISC e  serão em breve implantadas nesta ferramenta.</span>
      </p>
    </div>
    <nao-encontrada />
  </div>
</template>

<script>
import { setTimeout } from "timers";
import modalNaoEncontrada from "../../shared/modalNaoEncontrada";
import serviceHistorico from "../../services/ServiceHistorico";
export default {
  props: {
    selecionado: ""
  },
  components: {
    "nao-encontrada": modalNaoEncontrada
  },
  data() {
    return {
      pesquisa: "",
      validacaoNcm: false,
      loadingPesquisa: false,
      mensagemErro: "",
      estado: true
    };
  },

  methods: {
    emitirAlteracoes(valor) {
      this.$emit("alterado", valor);
    },
    async pesquisar() {
      if (this.pesquisa.length == 10) {
        this.validacaoNcm = false;
        this.loadingPesquisa = true;
        await serviceHistorico.getDadosNCM(this.pesquisa).then(
          res => {
            this.loadingPesquisa = false;
            if (res == "NCM não encontrada!") {
              this.$bvModal.show("ncmNaoEncontrada");
              this.mensagemErro = res;
            } else {
              this.$router.push({
                name: "Histórico",
                params: { ncm: this.pesquisa }
              });
            }
          },
          err => {
            this.loadingPesquisa = false;
            console.error("nao foi possivel obter dados do servidor");
          }
        );
      } else {
        this.validacaoNcm = true;
      }
    },
    
    mascara() {
      setTimeout(() => {
        this.pesquisa = this.pesquisa.replace(/\D/g, "");
        this.pesquisa = this.pesquisa.replace(/(\d{4})/, "$1.");
        this.pesquisa = this.pesquisa.replace(/(\d{4}).(\d{2})/g, "$1.$2.");
      }, 0.1);
    }
  },
   created(){
     function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
this.$store.state.idCliente =  getCookie("idCliente")
     if(this.$store.state.idCliente == '9475'){
      this.pesquisa = '8708.10.00'   
    }
  },
};
</script>

<style scoped>
.single-counter {
  min-height: 130px;
  max-height: auto;
  height: auto;
}
.erro {
  color: red;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.fs-12 {
  font-size: 12px;
}

.texto-italico {
  font-style: italic;
  line-height: 15px;
}
</style>